import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Api from 'utils/api';

class Invoices extends React.Component {
  constructor(props) {
    super(props);
    this.state = { invoices: null };
  };

  componentWillMount = () => {
    const api = new Api({ baseUrl: 'http://localhost:3001/api' });
    api.fetchInvoices()
      .then((invoices) => {
        this.setState({ invoices });
      });
  };

  renderinvoice = (invoice) => {
    return (
      <TableRow key={invoice.bank_invoice_id}>
        <TableCell>
          {invoice.invoice_number}
        </TableCell>
        <TableCell>
          {invoice.type}
        </TableCell>
        <TableCell>
          ${invoice.amount_paid}
        </TableCell>
        <TableCell>
          {invoice.bank_invoice_id}
        </TableCell>
        <TableCell>
          {invoice.reference}
        </TableCell>
        <TableCell>
          {invoice.status}
        </TableCell>
      </TableRow>
    );
  }

  render = () => {
    const { invoices } = this.state;

    return (
      <Table>
        <TableBody>
          { invoices && invoices.map((invoice) => this.renderinvoice(invoice))}
        </TableBody>
      </Table>
    )
  }
}

export default Invoices;



// WEBPACK FOOTER //
// ./src/components/Invoices/index.js